var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat109(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_109"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_109",
    "data-name": 109,
    className: "cls-2",
    d: "M2.14,47.2c-.72-11.72,36.23-27.72,67-22.34C84.82,27.59,100.75,40,97.42,57.52,91.27,89.87,48.83,72.13,30.07,64,11.63,55.93,2.43,51.91,2.14,47.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat109);
export default __webpack_public_path__ + "static/media/cat_109.6146ae16646ba7ba6862162f2c3f9d99.svg";
export { ForwardRef as ReactComponent };